import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { SelfServiceSlotStatus, type AdminSlot as SlotType } from 'modules/kiosk/types/Slot';

import { Button } from 'components/ui';
import { ButtonType } from 'components/ui/Button';
import { DEFAULT_MINUTES_TO_REOPEN_KIOSK } from 'modules/kiosk/constants';

const EmergencySlot: React.FC<Omit<SlotType, 'rack' | 'used'> & { used?: boolean; onOpen: () => void; disabled?: boolean }> = ({
  id,
  position,
  displayName,
  referenceId,
  registration,
  used,
  onOpen,
  disabled,
  status,
}) => {
  // Concats the registration and the displayName if they are both defined
  // Otherwise it returns the one that is defined
  const information = [referenceId, displayName].filter(Boolean).join(' - ');

  const isAssigned = status === SelfServiceSlotStatus.ASSIGNED;
  const isPreUnassigned = status === SelfServiceSlotStatus.PRE_UNASSIGNED;

  return (
    <li
      className={classNames('w-full p-7 bg-card-bg rounded-admin-card flex gap-x-8 items-center', {
        'border-2 border-solid border-border-default bg-white': !used,
        'bg-warning-default border-2 border-solid border-warning-default text-white': isPreUnassigned,
      })}
      data-testid={`slot-${id}`}
    >
      <div className="align-middle text-3xl font-bold pl-2">{position}</div>
      <div className="flex-1 flex flex-col">
        {registration && <div className="text-2xl font-bold">{registration}</div>}
        {isAssigned && information && <div className="text-xl">{information}</div>}
        {isPreUnassigned && (
          <span className="text-xl!">
            <FormattedMessage
              id="admin.slotReservation"
              defaultMessage="The slot is reserved for up to {minutes} minutes"
              values={{ minutes: DEFAULT_MINUTES_TO_REOPEN_KIOSK }}
            />
          </span>
        )}
      </div>
      <Button type={ButtonType.ERROR} onClick={onOpen} testId="open" disabled={disabled} className="text-button-xs! kiosk:py-4 kiosk:px-8">
        <FormattedMessage id="admin.manage.action.open" defaultMessage="Open slot" />
      </Button>
    </li>
  );
};

export default EmergencySlot;
